import React, { FC } from 'react'
import { slugs } from '@/constants/slugs'
import { ServerExperiments } from '@/experimentation'
import { ShopifyProductWithBundles } from '@/services/Shopify/ShopifyService'
import { PhaseSlug, SweepstakeObject } from '@/types/codegen-federation'
import { GiveawayLayout } from './GiveawayLayout'
import { GiveawayContextProvider } from './context/GiveawayContext'
import { GiveawayTypographyProvider } from './context/GiveawayTypographyProvider'
import { useGiveawayConfigData } from './hooks/useGiveawayConfigData'

export const vacationSlugs = new Set([slugs.braveTheDark, slugs.ruleBreakers])

interface Props {
  theatricalSlug: string
  tickets?: ShopifyProductWithBundles[]
  sweepstake: SweepstakeObject
  phase: PhaseSlug | null
  experiments?: ServerExperiments
  isTestSoloMio?: boolean
}

export const PreSalesGiveawayView: FC<Props> = ({
  tickets,
  theatricalSlug,
  phase,
  sweepstake,
  experiments,
  isTestSoloMio,
}) => {
  const giveawayData = useGiveawayConfigData({ theatricalSlug })

  if (!giveawayData) return null

  if (theatricalSlug === slugs.soloMio && !isTestSoloMio) return null

  return (
    <GiveawayTypographyProvider theatricalSlug={theatricalSlug}>
      <GiveawayContextProvider
        theatricalSlug={theatricalSlug}
        tickets={tickets}
        sweepstake={sweepstake}
        phase={phase}
        giveawayData={giveawayData}
        experiments={experiments}
      >
        <GiveawayLayout />
      </GiveawayContextProvider>
    </GiveawayTypographyProvider>
  )
}
